import { useMemo } from 'react';
import { v4 as uuid } from 'uuid';
import { Tooltip } from '@chakra-ui/react';

// TODO: Type declarations
export const Switch = ({ tooltip, embedded, onChange }: any) => {
  const id = useMemo(() => uuid(), []);

  return (
    <>
      <div data-tip data-for={`tooltip-${id}`}>
        <div style={{ width: embedded ? 20 : 0, transition: 'width 0.2s' }} />
        <div style={{ backgroundColor: '#FFFFFF', width: 20, height: 20, borderRadius: '50%' }} />
      </div>
      {tooltip && (
        <Tooltip id={`tooltip-${id}`}>
          <span>{tooltip}</span>
        </Tooltip>
      )}
    </>
  );
}
